module.exports = __webpack_public_path__ + "static/img/timg.8e427ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sliderVertify/images/timg.jpg
// module id = vs6u
// module chunks = 92